class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M13 8c0-.804-.195-1.597-.57-2.31l-.748.749c.21.494.319 1.025.318 1.561h1Zm-1.293-3L11 4.293 8.643 6.65a1.483 1.483 0 0 0-1.476.103A1.5 1.5 0 1 0 9.5 8a1.483 1.483 0 0 0-.15-.643L11.707 5ZM8 8.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM8 4c.536 0 1.068.108 1.561.318l.748-.748A4.993 4.993 0 0 0 3 8h1a4.005 4.005 0 0 1 4-4Z"></path><path d="M8 15a7 7 0 1 1 7-7 7.008 7.008 0 0 1-7 7ZM8 2a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6Z"></path></svg>';
  }
}
const t = "pi-meter";
customElements.get(t) || customElements.define(t, e);
export {
  e as default
};
